/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists, mapValues } from '../runtime';
import { GoogleProtobufValueFromJSON, GoogleProtobufValueToJSON, } from './';
export function GoogleProtobufStructFromJSON(json) {
    return GoogleProtobufStructFromJSONTyped(json, false);
}
export function GoogleProtobufStructFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'fields': !exists(json, 'fields') ? undefined : (mapValues(json['fields'], GoogleProtobufValueFromJSON)),
    };
}
export function GoogleProtobufStructToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'fields': value.fields === undefined ? undefined : (mapValues(value.fields, GoogleProtobufValueToJSON)),
    };
}
//# sourceMappingURL=GoogleProtobufStruct.js.map